import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import QRCode from 'qrcode';
import { ArrowRight, Camera, QrCode, Smartphone } from 'lucide-react';

const StoreQrPage: React.FC = () => {
    const { slug } = useParams<{ slug: string }>();
    const arUrl = `${window.location.origin}/store/${slug}/ar`;
    const menuUrl = `${window.location.origin}/store/${slug}`;
    const [qrDataUrl, setQrDataUrl] = useState('');

    useEffect(() => {
        QRCode.toDataURL(arUrl, {
            margin: 1,
            width: 512,
            color: {
                dark: '#111111',
                light: '#F6F3EE',
            },
        })
            .then(setQrDataUrl)
            .catch((error) => {
                console.error('Failed to generate AR QR code', error);
                setQrDataUrl('');
            });
    }, [arUrl]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4 text-white">
            <div className="card w-full max-w-md space-y-6 p-8 text-center">
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-primary/15">
                    <QrCode className="h-10 w-10 text-primary" />
                </div>
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold">QR WebAR</h1>
                    <p className="text-muted-foreground">
                        Este QR abre diretamente a experiencia WebAR no modo configurado pela loja.
                    </p>
                </div>

                <div className="rounded-2xl border border-[#2A2A2A] bg-[#111] p-4 text-left">
                    <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">URL publica AR</p>
                    <p className="mt-2 break-all text-sm text-white">{arUrl}</p>
                </div>

                <div className="space-y-3 rounded-[2rem] border border-[#2A2A2A] bg-[#0B0B0B] p-5">
                    <div className="overflow-hidden rounded-[1.5rem] bg-[#F6F3EE] p-3">
                        {qrDataUrl ? (
                            <img src={qrDataUrl} alt="QR Code da experiencia AR" className="w-full rounded-2xl" />
                        ) : (
                            <div className="flex aspect-square items-center justify-center rounded-2xl bg-[#111] text-muted-foreground">
                                <QrCode className="h-10 w-10" />
                            </div>
                        )}
                    </div>
                    <p className="text-xs text-muted-foreground">Escaneie no celular para abrir a rota AR da loja.</p>
                </div>

                <div className="flex flex-col gap-3 sm:flex-row">
                    <Link to={`/store/${slug}/ar`} className="btn-primary flex flex-1 items-center justify-center gap-2">
                        <Camera className="h-4 w-4" />
                        Abrir WebAR
                    </Link>
                    <a href={menuUrl} className="btn-secondary flex flex-1 items-center justify-center gap-2">
                        <Smartphone className="h-4 w-4" />
                        Abrir Cardapio
                    </a>
                </div>

                <a href={arUrl} className="btn-secondary flex w-full items-center justify-center gap-2">
                    Copiar/Abrir Link
                    <ArrowRight className="h-4 w-4" />
                </a>
            </div>
        </div>
    );
};

export default StoreQrPage;
